export default "__VITE_ASSET__C67qRsD5__"